// Add your JS customizations here
jQuery(document).ready(function($) {
	// Initiate WOW Animations
	new WOW().init();


	$('a[href*="#"]').on('click', function(e) {
		var href = $(this).attr('href');
		var target = href.substring(href.indexOf('#'));
		if (target.length > 1 && $(target).length) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: $(target).offset().top
			}, 800);
		}
	});



	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		// Extra scroll amount
		var extraHeight = 20;

		// Total trigger point
		var scrollTrigger = navHeight + extraHeight;

		if ($(document).scrollTop() > scrollTrigger) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	scrollbarState();

	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});

	// Menu - Hamburger
	$('.hamburger-wrap').click(function () {
		// var target = $(this).data('target');

		// If any menus open (icon active)
		if ($('body').hasClass('menu-open')) {
			$('.hamburger').removeClass('is-active');

			$('body').removeClass('menu-open parent-menu-open');
			$('.parent-menu').removeClass('open');
			$('.menu-block, .sub-menu, .child-menu').removeClass('open');
			$('.hasSub a, .hasChild a').removeClass('active');


			// If none open
		} else {
			$('.hamburger').addClass('is-active');

			$('body').addClass('menu-open parent-menu-open');
			$('.parent-menu').addClass('open');
		}
	});

	// No Parent Triggers
	$('.noParent a').click(function () {

		$('body').removeClass('parent-menu-open');

	});

	// Main Menu - Desktop
	$('#header-menu-left .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('.hamburger').addClass('is-active');

		$('#header-menu-left .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});

	$('#header-menu-right .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('.hamburger').addClass('is-active');

		$('#header-menu-right .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});
	$('#desktop-menu .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('#desktop-menu .hasSub a').removeClass('active');
		$('.sub-menu-column .menu-block, .child-menu-column .menu-block').removeClass('open')

		$(this).addClass('active');
		$(target).addClass('open');
	});
	$('#desktop-menu .hasChild a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('#desktop-menu .hasChild a').removeClass('active');
		$('.child-menu-column .menu-block').removeClass('open')

		$(this).addClass('active');
		$(target).addClass('open');
	});

	// Main Menu - Mobile
	$('#mobile-menu .hasSub > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});
	$('#mobile-menu .hasChild > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});


	// Menu Toggle
	if ($('.main-nav-toggle').length > 0) {
		$('.main-nav-toggle').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');
			var assocLink = $(this).data('link');

			// console.log(assocLink);

			$('.hamburger').addClass('is-active');
			$('body').addClass('menu-open');

			$('#header-menu-left .hasSub a').removeClass('active');
			$('#header-menu-right .hasSub a').removeClass('active');
			$('.menu-block').removeClass('open');
			$(target).addClass('open');
			$(assocLink).addClass('active');
		});
	}






	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		// Extra scroll amount
		var extraHeight = 20;

		// Total trigger point
		var scrollTrigger = navHeight + extraHeight;

		if ($(document).scrollTop() > scrollTrigger) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	scrollbarState();

	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});

	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();

		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});

	// On CTA click
	$('#cta-popup a').on('click', function() {
		setCookie('ctaPopupDismissed', 'true');
	});




	// Sliders

	$('.hero-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 6000,
		fade: true,
		cssEase: 'linear',
		prevArrow: $('.hero-arrow-left'),
		nextArrow: $('.hero-arrow-right'),
	});

	$('.reliable-data-slider-wrapper').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		adaptiveHeight: false,
		prevArrow: $('.reliable-data-arrow-left'),
		nextArrow: $('.reliable-data-arrow-right'),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1.2
				}
			}
		]
	});

	$('.global-testimonials-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: false,
		prevArrow: $('.global-testimonials-arrow-left'),
		nextArrow: $('.global-testimonials-arrow-right'),
	});

	$('.how-we-work-slider-wrapper').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		adaptiveHeight: false,
		prevArrow: $('.how-we-work-arrow-left'),
		nextArrow: $('.how-we-work-arrow-right'),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.meridian-slider').slick({
		slidesToShow: 2.25,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		infinite: false,
		draggable: false,
		swipe: true,
		touchMove: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1.25,
					slidesToScroll: 1,
					draggable: true,
					swipe: true,
					touchMove: true,
					swipeToSlide: true
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
					swipe: true,
					touchMove: true,
					swipeToSlide: true
				}
			}
		]
	});

	if ($(window).width() > 991) {

		var $slider = $('.meridian-slider');
		var isDragging = false;
		var startX = 0;
		var currentTranslate = 0;
		var startTranslate = 0;

		$slider.on('mousedown', '.slick-list', function(e) {

			if (e.button !== 0) {
				return;
			}

			isDragging = true;
			startX = e.pageX;
			startTranslate = currentTranslate = parseFloat($slider.find('.slick-track').css('transform').split(',')[4]) || 0;

			$slider.addClass('is-dragging');
			e.preventDefault();

		});

		$(document).on('mousemove.meridian', function(e) {

			if (!isDragging) {
				return;
			}

			var $track = $slider.find('.slick-track');
			var movement = e.pageX - startX;
			var minTranslate = $slider.find('.slick-list').width() - $track.outerWidth();

			currentTranslate = Math.max(minTranslate, Math.min(0, startTranslate + movement));

			$track.css('transform', 'translate3d(' + currentTranslate + 'px, 0px, 0px)');

		});

		$(document).on('mouseup.meridian', function() {

			if (!isDragging) {
				return;
			}

			isDragging = false;
			$slider.removeClass('is-dragging');

		});

	}

	$('.one-platform-load-more').on('click', function(e) {
		e.preventDefault();
		var $wrapper = $(this).closest('.one-platform-wrapper');
		$wrapper.find('.one-platform-item[data-mobile-hidden="true"]').removeAttr('data-mobile-hidden');
		$wrapper.find('.one-platform-load-more-wrap').hide();
	});

	// $('.worked-with-slider').slick({
	// 	slidesToShow: 6,
	// 	slidesToScroll: 1,
	// 	infinite: true,
	// 	arrows: true,
	// 	dots: false,
	// 	prevArrow: $('.worked-with-arrow-left'),
	// 	nextArrow: $('.worked-with-arrow-right'),
	// 	responsive: [
	// 		{
	// 			breakpoint: 992,
	// 			settings: {
	// 				slidesToShow: 3,
	// 				slidesToScroll: 3
	// 			}
	// 		}
	// 	]
	// });



	function equalHeight() {

		$('.equal-height').each(function() {

			var $items = $(this).find('.equal-height-item');
			var maxHeight = 0;

			$items.css('height', 'auto');

			$items.each(function() {

				var height = $(this).outerHeight();

				if (height > maxHeight) {
					maxHeight = height;
				}

			});

			$items.css('height', maxHeight + 'px');

		});

	}

	$(window).on('load resize', function() {
		equalHeight();
	});

	$('.equal-height').on('init setPosition', function() {
		equalHeight();
	});
	equalHeight();


	function onePlatformVideoSticky() {

		var $section = $('.one-platform-outer-wrapper');
		var $video = $section.find('.background-video-sticky');

		if (!$section.length || !$video.length) {
			return;
		}

		var scrollTop = $(window).scrollTop();
		var windowHeight = $(window).height();

		var sectionTop = $section.offset().top;
		var sectionHeight = $section.outerHeight();
		var sectionBottom = sectionTop + sectionHeight;

		var videoHeight = $video.outerHeight();

		var stickyTop = scrollTop;
		var maxVideoTop = sectionBottom - videoHeight;

		if (scrollTop <= sectionTop) {

			$video.css({
				position: 'absolute',
				top: 0,
				bottom: 'auto'
			});

		} else if (scrollTop + videoHeight >= sectionBottom) {

			$video.css({
				position: 'absolute',
				top: maxVideoTop - sectionTop,
				bottom: 'auto'
			});

		} else {

			$video.css({
				position: 'fixed',
				top: 0,
				bottom: 'auto'
			});

		}
	}

	$(window).on('scroll resize', function() {
		onePlatformVideoSticky();
	});
	onePlatformVideoSticky();


	$('.quality-assurance-items-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		adaptiveHeight: false,
		swipeToSlide: true,
		prevArrow: $('.quality-assurance-arrow-left'),
		nextArrow: $('.quality-assurance-arrow-right'),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2.5
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	if ($('.case-study-media-slider').length > 0) {
		$('.case-study-media-slider').each(function() {
			var slider = $(this);
			var parentRow = slider.closest('.row');
			var slideCount = slider.children('.case-study-media-slide').length;
			var counter = parentRow.find('.case-study-slide-counter');
			var prevArrow = parentRow.find('.single-case-study-arrow-left');
			var nextArrow = parentRow.find('.single-case-study-arrow-right');

			if (slideCount > 1) {
				slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					infinite: false,
					adaptiveHeight: false,
					swipeToSlide: true,
					fade: true,
					speed: 500,
					cssEase: 'linear',
					prevArrow: prevArrow,
					nextArrow: nextArrow
				});

				slider.on('afterChange', function(event, slick, currentSlide) {
					counter.find('.current-slide').text(currentSlide + 1);
				});
			}
		});
	}








	$('.categories-select2 select').select2({
		placeholder: 'Categories',
		width: '100%'
	});

	$('.archive-select2 select').select2({
		placeholder: 'Archive',
		width: '100%'
	});

	$('.archive-select2 select').on('select2:select', function(e) {

		var archive_url = $(this).val();

		if (archive_url) {
			window.location.href = archive_url;
		}

	});

	$('.case-study-category-filter select, .case-study-date-filter select').select2({
		width: '100%',
		minimumResultsForSearch: Infinity
	});


	$('.what-we-build-item').on('mouseenter', function() {

		var imageIndex = $(this).data('image');

		$('.what-we-build-hover-image').removeClass('active');
		$('.what-we-build-hover-image[data-image="' + imageIndex + '"]').addClass('active');

	});

	$('.data-hero-item').on('mouseenter', function() {

		var imageIndex = $(this).data('image');

		$('.data-hero-hover-image').removeClass('active');
		$('.data-hero-hover-image[data-image="' + imageIndex + '"]').addClass('active');

	});

	$('.ai-advanced-first-platform .hover-image-change-item').on('mouseenter', function() {

		var imageIndex = $(this).data('image');
		var section = $(this).closest('.ai-advanced-first-platform');

		section.find('.hover-image-change-hover-image').removeClass('active');
		section.find('.hover-image-change-hover-image[data-image="' + imageIndex + '"]').addClass('active');

	});

	$('.ai-advanced-what-changed .hover-image-change-item').on('mouseenter', function() {

		var imageIndex = $(this).data('image');
		var section = $(this).closest('.ai-advanced-what-changed');

		section.find('.hover-image-change-hover-image').removeClass('active');
		section.find('.hover-image-change-hover-image[data-image="' + imageIndex + '"]').addClass('active');

	});



	function matchContactDetailsHeight() {
		$('.video-logo-wrap-match').each(function() {
			var $section = $(this);
			var $absolute = $section.find('.video-logo-wrap');
			var $over = $section.find('.match-video-logo-height');

			if (!$absolute.length || !$over.length) {
				return;
			}

			$over.css('min-height', $absolute.outerHeight());
		});
	}

	$(window).on('load resize', matchContactDetailsHeight);

	$('.faq-load-more').on('click', function(e) {
		e.preventDefault();

		$('.faq-hidden-item').slideDown();

		$(this).parent('.btn-wrap').remove();
	});


	var $contactBlock = $('#mobile-general-contact-block');
	if (!$contactBlock.length) {
		return;
	}

	var $placeholder = $('<div class="mobile-contact-placeholder"></div>');
	$contactBlock.before($placeholder);

	var blockTop = $placeholder.offset().top;

	function updateContactBlock() {
		if (!$contactBlock.is(':visible')) {
			return;
		}

		var blockHeight = $contactBlock.outerHeight();
		var scrollTop = $(window).scrollTop();
		var windowHeight = $(window).height();
		var triggerPoint = scrollTop + windowHeight - 50;
		var unstickPoint = blockTop - blockHeight;

		if (blockTop <= triggerPoint && scrollTop < blockTop) {
			if (!$contactBlock.hasClass('is-fixed')) {
				$contactBlock.addClass('is-fixed');
				$placeholder.height(blockHeight).hide();
			}
		} else if (scrollTop < unstickPoint) {
			$contactBlock.removeClass('is-fixed');
			$placeholder.show().height(0);
		}
	}

	$(window).on('scroll resize load', function() {
		updateContactBlock();
	});

	updateContactBlock();

});
